
import React from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import CountUp from "react-countup";
import { motion } from "framer-motion";
import Icon from "@mdi/react";
import { mdiCrown, mdiEmoticonHappy, mdiTrophy, mdiSeal } from "@mdi/js";

// Define reusable animation configuration for scaling and fading effects
const scaleFadeMotion = {
  whileInView: { scale: 1 },     
  initial: { scale: 0.7 },        
  transition: {
    type: "linear",
    stiffness: 100,
    duration: 1,
  },
};

// Define floating animation configuration for icons
const floatMotion = {
  animate: { y: [0, -5, 0] },     
  transition: { repeat: Infinity, duration: 3, ease: "easeInOut" },
};

// Counter data array containing information for each statistics card
const data = [
  { icon: mdiCrown, count: 10, suffix: "K", label: "Premium Property" },
  { icon: mdiEmoticonHappy, count: 3000, suffix: "+", label: "Happy Customer" },
  { icon: mdiTrophy, count: 4, suffix: "", label: "Award Winning" },
  { icon: mdiSeal, count: 20, suffix: "", label: "Years Experience" },
];

// Main Counter component that displays statistics in a grid
export default function Counter() {
  return (
    <section className="section counter-section">
      <Container>
        <Row className="g-4">
          {/* Map through data array to create individual counter cards */}
          {data.map((item, index) => (
            <CardItem key={index} item={item} index={index} />
          ))}
        </Row>
      </Container>
    </section>
  );
}

// Individual card component for displaying each statistic
function CardItem({ item, index }) {
  return (
    <Col sm={6} lg={3}>
      {/* Wrapper with scale and fade animations */}
      <motion.div {...scaleFadeMotion}>
        <Card className="card-hover-animated counter-card mb-0 overflow-hidden h-100 position-relative">
          <Card.Body className="text-center position-relative z-2">
            {/* Floating icon animation */}
            <motion.div {...floatMotion}>
              <Icon path={item.icon} className="text-primary icon-size-60 mb-2"/>
            </motion.div>
            {/* Animated counter component */}
            <CountUp
              end={item.count}                    
              duration={8}                        
              suffix={item.suffix}                
              enableScrollSpy                     
              className="h1 text-white d-block"
            />
            {/* Decorative divider */}
            <div className="w-20 border bg-soft-primary border-1 mx-auto my-3"></div>
            {/* Statistic label */}
            <p className="text-white text-opacity-85 fs-18 mb-0">{item.label}</p>
          </Card.Body>
        </Card>
      </motion.div>
    </Col>
  );
}